// extracted by mini-css-extract-plugin
export var container = "_8i-0";
export var icon = "_8i-1";
export var text = "_8i-2";